module.exports = function (bootstrap) {
    bootstrap.directive('siteFooterTemp', ["$rootScope", "$state",  "$filter", "$window", "brand", "navigation", "sessionData", "aemContent", "taglines","session", "appId","teamsite", function ($rootScope, $state, $filter, $window, brand, navigation, sessionData, aemContent, taglines, session, appId, teamsite) {
        return {
            replace: true,
            scope: {
                showLanguages: '=',
                cmsCode: '=?',
                hideBuildDate: '=?',
                hideDisclosures: '=?'
            },
            controller: ["$scope", function ($scope) {
                var REGIONAL_LANGUAGES_CONTENT_ID = 'REGIONAL_LANGUAGES',
                    MBR_MEANINGFUL_ACCESS_LINK_ID = 'MBR_MEANINGFUL_ACCESS_LINK',
                    APPROVAL_FOOTER_MESSAGE_BEGIN = "CMS_",
                    APPROVAL_FOOTER_MESSAGE_END = "_FOOTER_MESSAGE";

                //var needHelpCoremetricsFlag = false;
                $scope.shouldShowLanguagesFooter = false;
                $scope.isFetchingLanguages = false;

                var hideMentalHealth = ['wybcbs','ndbcbs','idh','mincr','ibcr','ibcah','fl','mn','az', 'neb', 'pp','la'];
                if (hideMentalHealth.indexOf(brand.current.sharedBrandCode) > -1){
                    $scope.isPlanPartner = true;
                }
                
                $scope.isSenior = appId.toLowerCase() === 'medweb';
                $scope.isNDBCBS = brand.current.ubk=== 6011;
                $scope.ndLanguageAssistance = "https://www.bcbsnd.com/documents/10181/6527267/Language_and_Disability_Access_Assistance/f6538f54-3702-4ac6-9d46-9a8b8f981df3";
                $scope.isWYBCBS = brand.current.ubk=== 6012;
                $scope.translationServices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf";
                $scope.nonDiscriminationNotices = "https://www.bcbswy.com/docs/Translation_NonDiscrimination.pdf#page=2";
                $scope.nonDiscriminationNoticesND = "https://www.bcbsnd.com/documents/10181/6527267/Language_and_Disability_Access_Assistance/f6538f54-3702-4ac6-9d46-9a8b8f981df3";
                $scope.footerMoreInfo = {};
                $scope.isMINCR = (brand.current.sharedBrandCode === 'mincr') ? true : false;

                $scope.brandValue = brand.current.sharedBrandCode;
                $scope.cmsCode = $scope.cmsCode || function (stateName) {
                        $scope.footerMoreInfo = {"cmsCode": false};
                        if (stateName !== "") {
                            // FIXME: This code needs re-visited, but fixing prod issue for now because brand needs to be upper case for content info service...
                            teamsite.setQualifier('brand', (brand.current.umsBrandCode || brand.current.sharedBrandCode).toUpperCase());
                            teamsite.get(APPROVAL_FOOTER_MESSAGE_BEGIN + stateName.toUpperCase() + APPROVAL_FOOTER_MESSAGE_END).then(function (response) {
                                $scope.footerMoreInfo = {"cmsCode": response};
                            });
                        }
                    };
                

                //Footer Approval Logic

                if (typeof $scope.cmsCode === 'function') {
                    $scope.$watch(function () {
                            return $state.current.name;
                        }, function (stateName, previousStateName) {
                            if (stateName !== previousStateName && typeof $scope.cmsCode === 'function') {
                                $scope.cmsCode(stateName, $scope);
                            }
                        }
                    );
                }


                // Set up scope variables for languages and meaningful-access link.
                $scope.languages = [];
                $scope.meaningfulAccessURL = null;

                var populateFooterLanguagesMenu = function () {
                    if ($scope.isFetchingLanguages) {
                        return;
                    }
                    $scope.isFetchingLanguages = true;
                    // Get Languages content from the taglines factory.
                    $scope.languages = [];

                    var allLanguages = {};
                    taglines.getAllLanguages().then(
                        function (result) {
                            allLanguages = result;
                        }, function (error) {
                        }
                    ).finally(function () {
                        // Set up $scope.languages based off of teamsite.
                        teamsite.get(REGIONAL_LANGUAGES_CONTENT_ID).then(
                            function (response) {
                                var regionalLanguages = JSON.parse(response);
                                // For each langugage code in the languages property, ...
                                angular.forEach(regionalLanguages.languages, function (item) {
                                    // ...if the language code is in allLanguages, ...
                                    if (allLanguages[item]) {
                                        // ...push the language information from allLanguages into $scope.languages.
                                        $scope.languages.push(allLanguages[item]);
                                    }
                                });

                                $scope.isFetchingLanguages = false;
                            }, function (error) {
                                $scope.isFetchingLanguages = false;
                            }
                        );
                    });

                    // Get the URL for the meaningful-access page from teamsite.
                    teamsite.get(MBR_MEANINGFUL_ACCESS_LINK_ID).then(
                        function (response) {
                            var languageLink = JSON.parse(response);
                            $scope.meaningfulAccessURL = languageLink.href;
                        }, function (error) {
                        }
                    );

                };

                $scope.session = sessionData;
                $scope.footerLinkClick = function (link, $event) {
                    if ($window.innerWidth < 936) {
                        link.hideSub = !link.hideSub;
                        $event.stopPropagation();
                    }
                };

                $scope.isExpanded = function (link) {
                    var isHidden = link.hideSub || false;
                    return $window.innerWidth < 936 ? isHidden : true;
                };

                var footerResize = function () {
                    var footerLinksLength = 0;
                    for (var i in $scope.navigation.footerLinks) {
                        if (!$scope.navigation.footerLinks[i].hide) {
                            footerLinksLength++;
                        }
                    }
                    var ww = $window.innerWidth || $($window).width();
                    if (ww > 1243) {
                        var perColumn = Math.ceil(footerLinksLength / 4);
                        var remainder = footerLinksLength % 4;
                    }
                    else {
                        var perColumn = Math.ceil(footerLinksLength / 3);
                        var remainder = footerLinksLength % 3;
                    }

                    var column = 1;
                    var x = 1;
                    var reduced = false;
                    // var orderedLinks = $filter('orderByLink')($scope.navigation.footerLinks, 'order');
                    var orderedLinks = $scope.navigation.footerLinks || [];
                    var threeInFirstColumn = orderedLinks.filter(function(link) {return link.id == "memberPrePasswordPayPremium";}).length > 0;

                    // Angular cannot automatically sort objects in ngRepeat, so we use a custom filter.
                    // Since this filter is applied in the ngRepeat in html, we need to apply it here as well before we
                    // assign columns to each link.  If not, the links would be assigned columns in the order they appear
                    // in code, ignoring their order field.
                    for (var z = 0; z < orderedLinks.length; z++) {
                        if (!orderedLinks[z].hide) {
                            orderedLinks[z].column = column;
                            if (threeInFirstColumn) orderedLinks[2].column = 1;
                            if (x++ >= perColumn) {
                                column++;
                                x = 1;
                            }
                            if (remainder && !reduced && column > remainder) {
                                perColumn--;
                                reduced = true;
                            }
                        }
                    }
                };
                $scope.session = session.data;
                $scope.brandData = brand.current;
                $scope.navigation = navigation.data;
                $scope.buildDate = new Date($window.buildInfo.buildDate);
                $scope.$watch("navigation.footerLinks", function (a) {
                    if(typeof($scope.navigation.footerLinks) !== "undefined") {
                        if (window.location.href.indexOf('find-a-doctor') > -1 && !$scope.session.loggedIn && $scope.isWYBCBS) {
                            for (i = 0; i < $scope.navigation.footerLinks.length; i++) {
                                if ($scope.navigation.footerLinks[i].links.length > 0) {
                                    for (j = 0; j < $scope.navigation.footerLinks[i].links.length; j++) {
                                        if ($scope.navigation.footerLinks[i].links[j].label.indexOf("Privacy & Legal") > -1) {
                                            $scope.navigation.footerLinks[i].links.splice(j, 1);

                                        }
                                    }
                                }
                            }
                        }
                    }
                    footerResize();
                });
                $scope.$watch("session.loggedIn", function () {
                    $scope.shouldShowLanguagesFooter = taglines.shouldShowLanguages($scope.session.appConfig, $scope.showLanguages);
                    if ($scope.shouldShowLanguagesFooter) {
                        populateFooterLanguagesMenu();
                    }

                });
                angular.element($window).on('resize', function () {
                    footerResize();
                    $scope.$apply();
                });
            }],
            templateUrl: "home.appTemplate.html/chmhom/directives/footer"
        };
    }]);
};